import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  PersistConfig,
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from "redux-persist";
import storage from "redux-persist-indexeddb-storage/dist";
import { casesMiddleware } from "./middlewares";
import { offlineReducer, casesReducer } from "./slices";

const persistConfig: PersistConfig<any> = {
  key: "root",
  storage: storage("offline"),
  blacklist: ["offline"]
};

const reducer = combineReducers({
  offline: offlineReducer,
  cases: casesReducer
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(casesMiddleware)
});

export const persistor = persistStore(store);

export { offlineActions, casesActions } from "./slices";
